import React from 'react';
import { Brain, Code, Users, Zap, Target, Award } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import Contact from '../components/Contact';

const About = () => {
  const values = [
    {
      icon: Brain,
      title: 'Innovation First',
      description: 'We stay at the forefront of AI and technology, constantly exploring new solutions.'
    },
    {
      icon: Target,
      title: 'Client Success',
      description: 'Your success is our mission. We deliver solutions that drive real business value.'
    },
    {
      icon: Users,
      title: 'Top Talent',
      description: 'We hire and place only the best software engineers, AI specialists, and data scientists.'
    },
    {
      icon: Zap,
      title: 'Agile Excellence',
      description: 'Fast, iterative delivery with modern DevOps and continuous improvement.'
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
              About <span className="text-[#1A3E6E]">OneIT Solutions</span>
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              We are a leading provider of AI solutions, software development, and technology talent. 
              Our mission is to empower businesses with cutting-edge technology and world-class professionals.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              {/* <h2 className="text-3xl font-bold text-gray-900">Our Story</h2> */}
              <p className="text-gray-600 leading-relaxed text-justify">
                OneIT Solutions is a modern technology services company specializing in software development, digital solutions, IT consulting, AI-driven innovation, and professional staffing. We help organizations build scalable, secure, and future-ready systems that accelerate growth and improve operational efficiency.
              </p>
              <p className="text-gray-600 leading-relaxed text-justify">
                With strong expertise in cloud technologies, full-stack engineering, automation, and data-driven intelligence, we partner with businesses to deliver impactful, end-to-end solutions. Our AI services enable clients to leverage machine learning, generative AI, predictive analytics, and intelligent automation to transform processes and enhance customer experiences.
              </p>
              <p className="text-gray-600 leading-relaxed text-justify">
                From product development and system modernization to strategic consulting and IT talent delivery, OneIT Solutions provides the right technology and the right people to support every stage of your digital journey.
              </p>
              <p className="text-gray-600 leading-relaxed text-justify">
                <strong>Our mission:</strong><br />
                <strong>Empowering your digital journey with innovative solutions and trusted expertise.</strong>
             </p>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1758518731468-98e90ffd7430?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHRlYW18ZW58MHx8fHwxNzYzOTMxMDk3fDA&ixlib=rb-4.1.0&q=85"
                alt="Team"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900">Our Values</h2>
            <p className="mt-4 text-xl text-gray-600">The principles that guide everything we do</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => {
              const IconComponent = value.icon;
              return (
                <Card key={index} className="text-center hover:shadow-lg transition-shadow duration-300 border-2 hover:border-[#1A3E6E]">
                  <CardHeader>
                    <div className="mx-auto mb-4 w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center">
                      <IconComponent className="text-[#1A3E6E]" size={32} />
                    </div>
                    <CardTitle className="text-xl">{value.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-gray-600">{value.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <Contact />
    </div>
  );
};

export default About;
